module.exports = __webpack_public_path__ + "static/img/hatchback-red.ea92d0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hatchback-red.svg
// module id = v+ba
// module chunks = 74